import React, { SVGProps } from 'react'

const BackspaceIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="56"
      height="34"
      viewBox="0 0 56 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.4414 23.7363L40.5227 10.4067"
        stroke="#878787"
        strokeWidth="2.33733"
      />
      <path
        d="M16.7932 2L2 17.0741L16.7932 32.1482H54.1657V2H16.7932Z"
        stroke="#878787"
        strokeWidth="2.33846"
      />
      <path
        d="M27.4414 10.4082L40.5227 23.7378"
        stroke="#878787"
        strokeWidth="2.33733"
      />
    </svg>
  )
}

export default BackspaceIcon
